export const FRONTEND_STATE_DRAWING_IMAGE_SELECTOR_SET_EDITED_FILE_ID = 'FRONTEND_STATE_DRAWING_IMAGE_SELECTOR_SET_EDITED_FILE_ID';
export const FRONTEND_STATE_DRAWING_IMAGE_SELECTOR_SET_NEW_INSTANCE_FILE_ID = 'FRONTEND_STATE_DRAWING_IMAGE_SELECTOR_SET_NEW_INSTANCE_FILE_ID';
